import ObjectID from 'bson-objectid';

import { TFunction } from '@lyearn/i18n';
import { Blocks } from '@/components/PageEditor/types';

import { LessonStatusTypes } from '../../../../enums';

const getId = () => new ObjectID().toHexString();
export const EMPTY_SECTION_TITLE = 'Untitled Section';
export const EMPTY_LESSON_TITLE = 'Untitled Lesson';
export const EMPTY_LESSON_DESCRIPTION = 'Lesson Description';
export const EMPTY_LESSON_NOTES = 'Write something here...';

export const generateLesson = (
  t?: TFunction,
  title?: string,
  uploadFileUrl?: string,
  uploadFileUserId?: string,
) => {
  return {
    type: Blocks.LESSON,
    attrs: {
      id: getId(),
    },
    content: [
      {
        type: Blocks.TITLE,
        attrs: {
          id: getId(),
        },
        content: [
          {
            type: Blocks.TEXT,
            text: title || (t && t('Course:UntitledLesson')) || EMPTY_LESSON_TITLE,
          },
        ],
      },
      {
        type: Blocks.REF,
        attrs: {
          id: getId(),
          refId: getId(),
          uploadFileUrl: uploadFileUrl || null,
          uploadFileUserId: uploadFileUserId || null,
          refType: Blocks.LESSON_PAGE,
        },
      },
      {
        type: Blocks.DESCRIPTION,
        attrs: {
          id: getId(),
        },
        content: [
          {
            type: Blocks.TEXT,
            text: (t && t('Course:LessonDescription')) || EMPTY_LESSON_DESCRIPTION,
          },
        ],
      },
      {
        type: Blocks.COVER,
        attrs: {
          id: getId(),
        },
      },
      {
        type: Blocks.LESSON_COMMENTS,
        attrs: {
          id: getId(),
          commentThreadId: null,
        },
      },
      {
        type: Blocks.LESSON_ASSIGNEE,
        attrs: {
          id: getId(),
          userId: null,
        },
      },
      {
        type: Blocks.LESSON_STATUS,
        attrs: {
          id: getId(),
          status: LessonStatusTypes.None,
        },
      },
      {
        type: Blocks.LESSON_NOTES,
        attrs: {
          id: getId(),
        },
        content: [
          {
            type: Blocks.TEXT,
            text: EMPTY_LESSON_NOTES,
          },
        ],
      },
    ],
  };
};

export const generateSection = (t?: TFunction, title?: string) => {
  return {
    type: Blocks.SECTION,
    attrs: {
      id: getId(),
    },
    content: [
      {
        type: Blocks.TITLE,
        attrs: {
          id: getId(),
        },
        content: [
          {
            type: Blocks.TEXT,
            text: title || (t && t('Course:UntitledLesson')) || EMPTY_LESSON_TITLE,
          },
        ],
      },
      generateLesson(t),
    ],
  };
};
